import * as React from 'react';
import { IconProps } from '../types';

const IcMinus = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M5.75 10.75C5.05964 10.75 4.5 11.3096 4.5 12c0 .6904.55964 1.25 1.25 1.25h13.5c.6904 0 1.25-.5596 1.25-1.25 0-.6904-.5596-1.25-1.25-1.25H5.75Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcMinus;